import React from "react";

export const FlavorTab = ({ flavorTab, setFlavorTab }) => {
  return (
    <div className="container">
      <div className="collapse navbar-collapse" id="tab">
        <ul
          sx={{
            fontFamily: "'Cormorant Garamond', serif;",
          }}
          className="nav navbar-nav navbar-left"
        >
          <li>
            <button
              style={{
                background: "none",
                border: "none",
                color: "#ac3b61",
                fontWeight: 400,
                cursor: "pointer",
                position: "relative",
                paddingBottom: "4px",
                borderBottom:
                  flavorTab === "cakes"
                    ? "2px solid transparent" // Ensures space for underline
                    : "none",
                backgroundImage:
                  flavorTab === "cakes"
                    ? "linear-gradient(to right, #ac3b61 0%, #cc698b 100%)"
                    : "none",
                backgroundSize: "100% 2px",
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
              }}
              checked={flavorTab === "cakes"}
              onClick={() => setFlavorTab("cakes")}
              onMouseOver={(e) => (e.target.style.textDecoration = "none")}
              onMouseOut={(e) => (e.target.style.textDecoration = "none")}
              className="page-scroll"
            >
              Cakes & 3D Cakes
            </button>
          </li>
          <li>
            <button
              style={{
                background: "none",
                border: "none",
                color: "#ac3b61",
                fontWeight: 400,
                cursor: "pointer",
                position: "relative",
                paddingBottom: "4px",
                borderBottom:
                  flavorTab === "cupcakes"
                    ? "2px solid transparent" // Ensures space for underline
                    : "none",
                backgroundImage:
                  flavorTab === "cupcakes"
                    ? "linear-gradient(to right, #ac3b61 0%, #cc698b 100%)"
                    : "none",
                backgroundSize: "100% 2px",
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
              }}
              onClick={() => setFlavorTab("cupcakes")}
              onMouseOver={(e) => (e.target.style.textDecoration = "none")}
              onMouseOut={(e) => (e.target.style.textDecoration = "none")}
              className="page-scroll"
            >
              Cupcakes
            </button>
          </li>
          {/* <li>
            <button
              style={{
                background: "none",
                border: "none",
                color: "#ac3b61",
                fontWeight: 400,
                cursor: "pointer",
                position: "relative",
                paddingBottom: "4px",
                borderBottom:
                  flavorTab === "3d-cakes"
                    ? "2px solid transparent" // Ensures space for underline
                    : "none",
                backgroundImage:
                  flavorTab === "3d-cakes"
                    ? "linear-gradient(to right, #ac3b61 0%, #cc698b 100%)"
                    : "none",
                backgroundSize: "100% 2px",
                backgroundPosition: "bottom",
                backgroundRepeat: "no-repeat",
              }}
              checked={flavorTab === "desserts"}
              onClick={() => setFlavorTab("desserts")}
              onMouseOver={(e) => (e.target.style.textDecoration = "none")}
              onMouseOut={(e) => (e.target.style.textDecoration = "none")}
              className="page-scroll"
            >
              Desserts
            </button>
          </li> */}
        </ul>
      </div>
    </div>
  );
};
